export default function CustomerSelect({customers, setActiveCustomer}) {
    let customerList = [
        <option key={"loading"} value={"loading"}>Please select a customer</option>
    ];
    return (
        <div className="py-10">
            <label htmlFor="location" className="text-base font-semibold text-gray-900">
                Customer
            </label>
            <select
                id="customer"
                name="customer"
                className="mt-2 block w-full rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                defaultValue="Select a Customer"
                onChange={(e) => setActiveCustomer(e.target.value)}
            >
                {customerList.concat(Object.keys(customers).map((customer) => {
                    return <option key={customer} value={customer}>{customers[customer].company_name}</option>;
                }))}
            </select>
        </div>
    )
}